import { render, staticRenderFns } from "./NhapDienNoiBo.vue?vue&type=template&id=6c830671"
import script from "./NhapDienNoiBo.vue?vue&type=script&lang=js"
export * from "./NhapDienNoiBo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports